/* global _E, view_placing_reference, Q, allViews, view_links,ensure, View, nf */


//ensure.style("^bac_view_default");
/* placement of view system*/
window.top_z_index = 1;
(function () {

    random_rgba = function (opacity) {
        return "rgba(" + parseInt(Math.random() * 70 + 195) + "," + parseInt(Math.random() * 70 + 195) + "," + parseInt(Math.random() * 70 + 195) + "," + opacity + ")";
    };

    var z_contor = 1;
    view_placing_reference = _E("<div view_placing_reference style='position:relative;z-index:10;width: calc(100vw - 60px);'></div>");


    view_links = _E("<div view_links style='position:absolute;z-index:15000;top:100px;'></div>");

    let view_killer = _E('<icon>close</icon>').css("font-size:1.5em;font-weight:100;color: #555;cursor:pointer;margin-bottom:.1em").setA({ title: "CLOSE ALL", hidden: true });
    view_killer.on("click", (ev) => {
        view_killer.confirm({
            text: "CLOSE ALL VIEWS",
            ok: () => {
                [...allViews].map(v => {
                    v.close();
                });
            },
            init: function (_i) {
                _i.parent.css({ position: 'fixed', top: '90px' });
            }
        });

    });

    var min_all = _E('<m minimize_all_views></m>').css("font-size:1.3em;font-weight:100;color: #555;cursor:pointer;margin:.1em;translateY(-10px)").setA({ title: "MINIMIZE ALL", hidden: true });
    min_all.on("click", (ev) => {
        allViews.map(v => {
            v.minimize();
        });
    });
    view_links._(view_killer, min_all);

    window.addEventListener('load',
        function () {
            document.body._top(_E().css('position:absolute;top:0;left:0')._(
                view_placing_reference._(
                    Blinder,
                    _E("<div style='position:fixed;z-index:100000'></div>")._(view_links))));
        }
        , false);

    var topView = _E(), viewCount = 0;
    allViews = [];
    View = function (arg) {
        /* BUILD STRUCTURE */
        var V = this;
        V.frame = _E().setA('view_frame').setA('opacity_inout');
        V.frame.view = V;
        V.frame.css({
            transform: "translate(" + (parseInt(Math.random() * 100) + 40) + "px," +
                (parseInt(Math.random() * 100) + 60 + window.scrollY) + "px)",
            "z-index": 9999
        });

        // the head with icon bara_titlu and buttons
        var head = V.head = _E().css("position:relative;padding:0 4px 0 0;cursor:move;border-radius:8px 8px 0 0;");
        head.on("mousedown", coverViews);
        head.on("mouseup", unCoverViews);

        var btn_holder = _E().css("height:0;overflow:visible"); V.btn_holder = btn_holder;
        var icon = V.icon_tag = _E('', ++viewCount).setA('view_icon');
        var bara_titlu = _E('', '_________________ ').setA('view_bara_titlu');
        var mini = _E().css("cursor:pointer;z-index:1;padding:.8em .5em;height:1.9em;position:absolute;right:2.1em");
        mini._(_E().css("border-top:.13em solid;width:1em"));
        var kill = _E('kill').css("font-size:1.2em;right:0;position:absolute;opacity:.9;");

        // FIXED POSITION OF VIEW
        V.fixed_poz_sw = _E("view_fixer").css("z-index:1");
        V.fixed_poz_sw.on("click", (ev) => { V.magnetic = V.fixed_poz_sw.togA('active') });


        btn_holder._(V.fixed_poz_sw)._(mini)._(kill);
        head._(icon)._(bara_titlu);



        V.frame._(btn_holder)._(head);
        head.dragParent();
        head.on("pointerdown", coverViews);
        head.on("pointerup", unCoverViews);


        var leftBar = _E().setA('vert_bar');
        leftBar.which = 'leftBar';


        V.cover = _E().setA("view_cover");
        V.content = _E().setA('view_content');
        V.content.oo = V;
        var rightBar = _E().setA('vert_bar').css("left:-3px;");
        rightBar.which = 'rightBar';
        V.frame._(_E().setA('rel')._(V.cover)._(leftBar)._(rightBar.css("margin-left:100%"))._(V.content));

        //bottomBar and corners
        var leftCorner = _E().setA('left_corner');
        leftCorner.which = 'leftCorner';
        var footBar = _E().setA("footBar");
        footBar.which = 'footBar';
        var rightCorner = _E().setA('right_corner');
        rightCorner.which = 'rightCorner';
        V.frame._(_E().css("float:left;position:relative;")._(leftCorner))._(
            footBar._(_E().css("position:relative;margin-left:100%")._(rightCorner)))._(_E().css("clear:both"));

        view_placing_reference._(V.frame);// append to document to have acces to offsets


        [leftCorner, rightCorner, leftBar, rightBar].map(s => s.on("touchstart", ev => {
            ev.preventDefault();
        }));
        //V.jumpTop();
        //allViews[0]=viewCount;




        // put a link on view_links
        var vlink = _E("<div view_link noselect></div>");//_E().setA("view_link").setA("scaly").setA('noselect');
        V.link = vlink;
        view_links._(_E().setA('link_holder')._(vlink));
        view_killer.remA("hidden");
        min_all.remA("hidden");

        /* SIZING PROPERTIES*/
        //!!!! NOT anonimous function
        function resizeTitle() {
            bara_titlu.style.width = (Math.max(120, parseInt(V.content.style.width) - 130)) + 'px';
        }


        /* ENABLE SHAPING  ELEMENTS */
        [rightBar, leftBar, rightCorner, leftCorner, footBar].forEach(function (o) {
            enableViewHandling(o, V);
        });

        /* EVENTS*/
        V.jumpTop = function () {
            if (V.frame.style.zIndex != top_z_index) {
                top_z_index = ++z_contor;
                V.frame.style.zIndex = top_z_index;
                V.frame.parent.underlay && view_placing_reference._(V.frame);
            }
        };

        V.frame.on('pointerdown', V.jumpTop, true);
        //remove view and link
        kill.on('click', function (ev) {
            ev.stopImmediatePropagation();
            ev.stopPropagation();
            ev.preventDefault();
            if (!V) {
                // x-leave   view in view poate elimina un view dar ramane eventul 
                return;
            }
            V.frame.die();
            vlink.parentNode.die();
            if (V.button) {
                V.button.view = null;
            } // rup asocierea cu x-view sau alt element care foloseste View
            allViews.remove(V);
            if (!allViews.length) {
                view_killer.setA("hidden");
                min_all.setA("hidden");
            }
            (V.exit || nf).bind(V)();
            V = null;
        }, true);
        V.close = function () {
            kill.click();
        };
        //hide view
        mini.on('click',
            function () {
                V.frame.css("opacity:0;z-index:9999;display:none");
                vlink.style.opacity = .6;
                V.visible = false;
                topView = _E();//resolve conflict with frame.click()				
            }
        );
        V.minimize = function () {
            mini.click();
        };
        V.de_minimize = function () {
            V.jumpTop();
            if (V.visible)
                return;
            vlink.style.opacity = 1;
            V.visible = true;
            V.frame.style.display = "block";
            V.frame.fade(1);
        };
        V.hide = function () {
            [V.frame, vlink].as1("css")("display:none");

        };
        V.show = function () {
            [V.frame, vlink].as1("css")("display:block");
            V.closed = false;
        };
        vlink.on('mousedown,touchstart,click', function () {
            V.de_minimize();
        });

        vlink.on("touchstart", function (e) {
            e.preventDefault();
        }, true);
        vlink.on("touchend", function () {
            document.body.focus();
        });

        // HOLD
        vlink.on('hold', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var x0 = V.frame.x, y0 = V.frame.y, x1 = parseInt(40 + pageXOffset), y1 = parseInt(pageYOffset + 100 + this.offsetTop);
            if (x0 === x1 && y0 === y1) {
                return;
            }
            var magnetic = V.frame.style.position === 'fixed';
            if (magnetic) {
                V.fixed_poz_sw.click();
            }
            V.jumpTop();
            // daca pun x1,y1 are un salt ciudat
            V.frame.toXY(parseInt(40 + pageXOffset) + "," + parseInt(pageYOffset + 100 + this.offsetTop), null, () => {
                if (magnetic) {
                    V.fixed_poz_sw.click();
                }
            });
        }, true);





        /* PROPERTIES  & METHODS */
        V.trig('height', function (x) {
            V.content.style.height = parseInt(x) + 'px';
        }, 150);
        V.trig('width', function (x) {
            V.content.style.width = parseInt(x) + 'px';
            resizeTitle();
        }, 200);
        V.trig('title', function (x) {
            bara_titlu.innerHTML = "<m style='font-size:1.1em;_font-weight:bold;'>" + x.split("?")[0] + "</m>";
            vlink.setAttribute('title', x.replace(/<\\?.*?>/gim, ''));
        });
        V.trig('color', function (x) {
            bara_titlu.style.backgroundColor = x;
            vlink.style.backgroundColor = x;
        });
        V.trig('icon', function (x, number) {
            vlink.innerHTML = icon.innerHTML = number ? x : "<img src='" + x + "'/>";
        });


        Object.defineProperty(V, 'load', {
            value: function (adr, opt) {
                opt = opt || {};
                var CH = V.content.get({
                    src: adr,
                    cb: function () { // nu mai e nevoie pt ca  in EP.get isi face auto init si run
                        // V.content.init();
                        //V.content.run();
                    }
                }.tail(opt));
                //V.title = adr;
                V.title = /([^\/]*?)(\..*)?$/gim.exec(adr)[1];
                (opt.cb || nf)();
                V.content.fire("load", { src: adr });
                return CH;
            }
        });
        V.trig('src', V.load);
        V.trig('location', function (x) {
            var ifr = _E('iframe').setA('view_content').setA('src', x);
            V.content.replaced(ifr);
            V.content = ifr;
            ifr.css("padding:0;");

            V.title = x;
            V.width = 600;
            V.height = 300;
        }
        );

        /* INITIALIZING */

        vlink.innerHTML = icon.innerHTML;
        V.visible = true;
        V.height = 400;
        V.width = 600;
        V.color = random_rgba(.9);
        var o = arguments[0];
        if (typeof o === 'object') {
            for (var t in o) {
                V[t] = o[t];
            }
        }




        allViews.push(V);
        V.jumpTop();
        return V;
    };


    View.prototype.reveal = function (magnetic) {
        this.link.fire("click");
        this.link.fire("hold");
        this.frame.scale(1.02, .5, () => {
            if (magnetic) {
                this.magnetic = true;
            }
        }, sin);

    }


    View.prototype.toString = function () {
        return "View";
    };
    View.prototype.register = function () {
        view_links._(_E().setA('link_holder')._(this.link));
        view_placing_reference._(this.frame);
    };


    View.see = function (src, o) {
        let
            v = new View(),
            e = _E("embed").setA("src", src).css("width:100%;height:100%");
        v.content._(e);
        v.tail(o);
    }


    function rLeft(o, dx) {
        if (o.view.width > 260 || dx < 0) {
            o.view.width = o.width - dx;
            o.view.frame.style.transform = "translate(" + (o.tx + dx) + "px," + o.ty + "px)";
            //o.view.frame.style.left = o.Xo + dx + 'px';
        }//
    }
    function rRight(o, dx) {
        if (o.view.width > 260 || dx > 0)
            o.view.width = o.width + dx;
    }
    function rFoot(o, dy) {
        if (o.view.height > 100 || dy > 0)
            o.view.height = o.height + dy;
    }
    /* SHAPING CODE ---> */
    function reshapeView(e) {
        e.stopPropagation();
        var o = reshapeData;
        var dx = e.clientX - o.mXo;
        var dy = e.clientY - o.mYo;

        switch (o.which) {
            case 'rightBar':
                rRight(o, dx);
                break;
            case 'leftBar':
                rLeft(o, dx);
                break;
            case 'rightCorner':
                rRight(o, dx);
                rFoot(o, dy);
                break;
            case 'leftCorner':
                rLeft(o, dx);
                rFoot(o, dy);
                break;
            case 'footBar':
                rFoot(o, dy);
        }
        fire_resized(o)
    }

    /*   var fire_resized = (function (x) {
          console.log(x.view)
      }).debounce(100); */
    var fire_resized = (function (x) {
        x.view.content.fire("resized");
    }).throttle(100);



    var reshapeData;
    function enableViewHandling(elm, view) {
        elm.AEL('pointerdown',
            function (e) {
                e.stopImmediatePropagation();// prevent hendlers overlaping
                reshapeData = {// record state before reshaping
                    'view': view,
                    'which': this.which,
                    'mXo': e.clientX,
                    'mYo': e.clientY,
                    'Xo': view.frame.offsetLeft,
                    'width': view.width,
                    'height': view.height,
                    tx: view.frame.tx,
                    ty: view.frame.ty
                };
                document.onselectstart = function () {
                    return false;
                };//prevent selections for IE
                e.preventDefault();// prevent selections for FF
                document.body.focus();
                coverViews();
                document.addEventListener('pointermove', reshapeView);
            }
            , false);
    }

    document.addEventListener('pointerup', function (ev) {
        reshapeData = null;
        unCoverViews();
        document.onselectstart = null;
        document.removeEventListener('pointermove', reshapeView);
        //console.log(ev.target)
    }, false);
    /* <--- SHAPING CODE  */

    coverViews = function () {
        allViews.forEach(function (view) {
            view.cover.style.display = 'inline-block';
            //view.cover.style.background = '#ccc'
        });
    };
    unCoverViews = function () {
        allViews.forEach(function (view) {
            view.cover.style.display = 'none';
        });
    };
})();

Object.defineProperty(View.prototype, 'ai', {
    value: function () {
        var $ = this;
        //console.log($.query);
        $.ai_btn = _E("img").setA("ai_logo");
        $.btn_holder._($.ai_btn);
        this.ai_btn.context_menu({
            TEXTERIZE: {
                icon: `<span class="material-symbols-outlined">
                            text_fields
                        </span>`,
                do: () => {  // nu pot browser side cu kreuzberg ca ar lua o vesnicie fara CUDA
                    ask("grid.txtr", {

                        file: $.query.url,
                        //file: encodeURI(`http://10.10.10.111:33330/ne.myadr.ro/acz_gbe/212/daf/AA7_12.11.2025_GBE_AV037807_semnat (1).pdf`),
                        //file: encodeURI(`/qfs/tmp/b431aaa415fc8f065570e40d60e77748.pdf`),
                        export: "html"
                    }, r => {
                        var R = r.parsed
                            , v = new View(),
                            e = _E('div', R.result).setA("doclinc"),
                            style = e.find("style", 1);
                        style.html = `
    @import url("/aha/css/doclinc.css");
    @scope([doclinc]){
    ` + style.html + "}";
                        v.content._clr(e);
                    }
                        , null, {
                        timeout: 0,
                        loader: 'circle'
                    })
                },

                hint: "",
            },
            SUMARIZE: {
                do: Q.i,
                icon: `<span class="material-symbols-outlined">
                        summarize
                        </span>`,
                hint: "",
            },
            TRANSLATE: {
                icon: "translate",
                do: Q.i
            },
            CHAT: {}
        });
        this.ai_btn.on("click", function (ev) {
            ev.stopImmediatePropagation();
            ev.stopPropagation();
            ev.preventDefault();
            this.fire("contextmenu", { x: ev.pageX, y: ev.pageY });
        });
    }
});


Object.defineProperty(View.prototype, 'magnetic', {
    get: function () {
        return this.fixed_poz_sw.hasA("active");
    },
    set: function (v) {
        let $ = this;
        if (v) {
            $.frame.css({
                position: "fixed",
                top: parseInt($.frame.y - window.scrollY) + "px",
                left: parseInt($.frame.x - window.scrollX) + "px",
                transform: "translate(0px,0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale(1) skew(0deg)"
            });
            $.fixed_poz_sw.setA("active");
        } else {
            $.frame.css({
                position: "absolute",
                top: 0,
                left: 0,
                transform: "translate(" + parseInt($.frame.x) + "px," + parseInt($.frame.y) + "px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale(1) skew(0deg)"
            });
            $.fixed_poz_sw.remA("active");
        }
    }
});

// jump to page x of odf
Object.defineProperty(View.prototype, 'jump_to_page', {
    value: function (n) {
        var ifr = this.content.find("iframe", 1);
        if (ifr) {
            var src = ifr.getA("src").split("#")[0];
            ifr.src = "about:blank"; // 
            ifr.src = src + '#page=' + n + '&_=' + Date.now();
        } else {
            console.log("no pdf content");
        }
    }
});


//console.log(__ML__);;
class Monitor {
    constructor(o) {
        this.conf = o || {};
    }
    set data(o) {
        this.init();
        this.wrap.html = Q.o2ul(o, this.conf.steps || 5)[0];
    }
    init() {
        if (!allViews.has(this.view)) {
            this.view = new View;
            this.view.monitor = this;
            this.view.color = "black";
            this.wrap = _E().css({ position: "absolute", color: this.conf.color || "white", font: ".9em monospace" });
            this.view.content.css({ background: this.conf.background || "black" })._(this.wrap);
            this.view.height = this.conf.height || 600;
            this.view.width = this.conf.width || 400;
            this.view.frame.css({ background: "black", color: "white", "z-index": "3000000 !important" });
            _E("<span style='margin: 0 0 0 3em;font-size:.9em;font-family:monospace'><m yc >JS-MON: </m>" + ((this.conf.title || "---")) + "</span>").oust(this.view.frame.find("[view_bara_titlu]", 1));
            this.view.frame.find("[view_icon]", 1).css({ background: "transparent" });
            this.view.link.style.color = "white";
        }
    }
}
/** EX
 var MON1 = new Monitor({title: "div1.geometry"}), MON2 = new Monitor({height: 200, width: 300, background: "brown"});
svg1.reflect({attributes: true, childList: true, characterData: true, subtree: true}, function () {
    return;
                    t
    setTimeout(function () {
        var G = svg1.geometry;
        MON1.data = G;
    }, 300);
})
 */



